export default __webpack_public_path__ + "static/media/2193.d5794e59.png";